import { singletonFactory } from './singletonFactory'

export default singletonFactory
